import React, { useState, useEffect } from "react";
import "./Count.css";

const data = [
  {
    number: 125,
    heading: "Creative ideas",
    description:
      "Empowers people of team by adding strength to their abilities of teamwork and productivity",
  },
  {
    number: 325,
    heading: "Overseas operations",
    description:
      "Locations of foreign countries, across a sea or an ocean accomplished mining - quarry projects",
  },
  {
    number: 800,
    heading: "Domestic operations",
    description:
      "Economic transaction mining project that going to take place inside geo graphical boundaries",
  },
];

const Count = () => {
  const [counts, setCounts] = useState(data.map(() => 0));
  const [isHovered, setIsHovered] = useState(false); // State to track hover status

  useEffect(() => {
    const intervalIds = data.map((item, index) => {
      const increment = Math.ceil(item.number / 100); // Smooth counting increment
      const interval = setInterval(() => {
        setCounts((prevCounts) => {
          const newCounts = [...prevCounts];
          if (newCounts[index] < item.number) {
            newCounts[index] = Math.min(newCounts[index] + increment, item.number);
          }
          return newCounts;
        });
      }, 30); // Speed of counting

      return interval;
    });

    return () => {
      intervalIds.forEach(clearInterval);
    };
  }, []);

  return (
    <div
      className={`full-count ${isHovered ? "hovered" : ""}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <hr />
      <div className="count-container-c">
        <div className="count-list-c">
          {data.map((item, index) => (
            <div className="count-item-c" key={index}>
              <h1 className="count-number-c">{counts[index]}+</h1>
              <div className="count-text-c">
                <h2 className="count-heading-c">{item.heading}</h2>
                <p className="count-description-c">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <hr />
    </div>
  );
};

export default Count;
